import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "RO",
  "use": "RO-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"RO\"><path fill=\"#002B7F\" d=\"M4 5C1.791 5 0 6.791 0 9v18c0 2.209 1.791 4 4 4h8V5H4z\" /><path fill=\"#FCD116\" d=\"M12 5h12v26H12z\" /><path fill=\"#CE1126\" d=\"M32 5h-8v26h8c2.209 0 4-1.791 4-4V9c0-2.209-1.791-4-4-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol